module.exports = __webpack_public_path__ + "img/IMG_5002_FoamcoreMatted.7594e8ca.jpg";